import { Grid, GridItem } from "@chakra-ui/react";
import { useConnectedUser } from "../../../hooks/user.hooks";
import OrdersCommandTypeFilter from "../filters/OrdersCommandTypeFilter";
import OrdersHaltedFilter from "../filters/OrdersHaltedFilter";
import OrdersMaterialFilter from "../filters/OrdersMaterialFilter";
import OrdersManagerFilter from "../filters/OrdersModerlerFilter";

const OrdersSubToolbar = () => {
    const user = useConnectedUser();

    if (!user) return null;
	return (
		<Grid templateColumns="210px 210px 180px 1fr" alignItems="center" gap={2}>
			<GridItem>
				<OrdersCommandTypeFilter />
			</GridItem>
            {user.isSuperAdmin && <GridItem>
                <OrdersManagerFilter />
            </GridItem>}
			<GridItem>
				<OrdersMaterialFilter />
			</GridItem>
			<GridItem>
				<OrdersHaltedFilter />
			</GridItem>
		</Grid>
	);
};

export default OrdersSubToolbar;
